import axios from 'axios';
import debounce from 'debounce';
import deepmerge from 'deepmerge';

const getProjectPath = projectId => {
  let path = '/projects';
  if (projectId) {
    path += '/' + projectId;
  }
  return path;
};

const getProjectImagePath = (projectId, imageId) =>
  getProjectPath(projectId) + '/images/' + imageId;

const getProjectDocumentPath = (projectId, imageId) =>
  getProjectPath(projectId) + '/documents/' + imageId;

let gAttrs = null;
let updateProjectProc = debounce(function(projectId, onSuccess, onError) {
  axios
    .put(getProjectPath(projectId), { project: gAttrs })
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
  gAttrs = null;
}, 500);

let updateMCCheckedProc = debounce(function(projectId, attrs, onSuccess, onError) {
  axios
    .post(getProjectPath(projectId) + '/mc_checked', { checks: attrs })
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
}, 500);

let updateStateProc = debounce(function(projectId, onSuccess, onError) {
  axios
    .post(getProjectPath(projectId) + '/send_to_designer')
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
}, 500);

export const ProjectApi = {
  updateProject: (projectId, attrs, onSuccess, onError) => {
    if (gAttrs == null) {
      gAttrs = attrs;
    } else {
      gAttrs = deepmerge(gAttrs, attrs);
    }
    updateProjectProc(projectId, onSuccess, onError);
  },

  updateMCChecked: (projectId, attrs, onSuccess, onError) => {
    updateMCCheckedProc(projectId, attrs, onSuccess, onError);
  },

  updateState: (projectId, onSuccess, onError) => {
    updateStateProc(projectId, onSuccess, onError);
  },

  uploadFiles: (projectId, path, files, kind, onSuccess, onError) => {
    let cnt = files.length;

    var data = new FormData();
    data.append('kind', kind);
    for (var i = 0; i < cnt; i++) {
      data.append(`${path}[]`, files[i]);
    }

    axios
      .post(getProjectPath(projectId) + `/${path}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },

  deleteImage: (projectId, id, onSuccess, onError) => {
    axios
      .delete(getProjectImagePath(projectId, id))
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },

  deleteDocument: (projectId, id, onSuccess, onError) => {
    axios
      .delete(getProjectDocumentPath(projectId, id))
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },

  requestProjectRestart: (id, onSuccess, onError) => {
    axios
      .post(getProjectPath(id) + '/request_unpause')
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },

  requestProjectMoreTime: (id, onSuccess, onError) => {
    axios
      .post(getProjectPath(id) + '/request_more_time')
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },

  requestAdditionalTime: (onSuccess, onError) => {
    axios
      .post(getProjectPath() + '/request_additional_time')
      .then(response => {
        onSuccess(response.data);
      })
      .catch(onError);
  },
};



// WEBPACK FOOTER //
// ./app/javascript/customer_project/api/project-api.js